import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import { Button } from '../../../../components/Button/Button';
import { Modal, ModalRef } from '../../../../components/Modal/Modal';
import { useLanguage } from '../../../../locale/useLanguage';
import './SaveModal.css';

type SaveModalProps = {
  onSave?: () => void;
  onExit?: () => void;
};

export const SaveModal: React.ForwardRefExoticComponent<
  SaveModalProps & React.RefAttributes<ModalRef>
> = forwardRef(({ onSave, onExit }, forwardedRef) => {
  const [t] = useLanguage();
  const modalRef = useRef<ModalRef>(null);

  useImperativeHandle(forwardedRef, () => ({
    openModal: modalRef.current!.openModal,
    closeModal: modalRef.current!.closeModal,
  }));

  return (
    <Modal ref={modalRef}>
      <h3 className="modal-title">{t('searchAddressView.modalSaveTitle')}</h3>
      <p className="modal-description">
        {t('searchAddressView.modalSaveDescription')}
      </p>
      <div className="modal-button-container">
        <Button
          onClick={onSave}
          label={t('searchAddressView.modalSave')}
          isPrimary
        />
        <div className="save-modal--exit-button">
          <Button
            onClick={onExit}
            label={t('searchAddressView.exitWithoutSave')}
          />
        </div>
      </div>
    </Modal>
  );
});
